<ng-container *cbWaitFor="lotMappedItem$$ | async">
    @if (!lotConsentViewService.consent) {
        <cb-lot-consents-list [lotDto]="lotDto"></cb-lot-consents-list>
    }
    @if (lotConsentViewService.isBuildingConsent) {
        <cb-manage-building-consent
            (reloadLotMappedItem)="reloadLotMappedItem.emit()"
            class="flex-col flex"
            [lotDto]="lotDto"
        ></cb-manage-building-consent>
    }
    @if (lotConsentViewService.isResourceConsent) {
        <cb-manage-resource-consent
            class="flex-col flex"
            [lotDto]="lotDto"
            (reloadLotMappedItem)="reloadLotMappedItem.emit()"
        ></cb-manage-resource-consent>
    }
</ng-container>
